import { Component, OnInit, Output, EventEmitter, OnDestroy, OnChanges, forwardRef, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { Subscription } from 'rxjs';

import { RelationshipDataItem } from '../models/partner';
import { PartnershipService } from '../partnership.service';
import { PartnerRelationship } from '../models/PartnerRelationship';

@Component({
  selector: 'app-asset-id-dropdown',
  templateUrl: './asset-id-dropdown.component.html',
  styleUrls: ['./asset-id-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssetIdDropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AssetIdDropdownComponent),
      multi: true
    }
  ]
})
export class AssetIdDropdownComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {

  @Input() relationshipId: number;
  @Input() relationshipDataItemSelected: RelationshipDataItem[];
  @Input() filterPlaceHolder: string;
  @Input() defaultLabel: string;
  @Output() onChange = new EventEmitter<RelationshipDataItem[]>();

  subscription: Subscription;
  disabled: boolean;
  processing = false;
  relationshipDataItem: RelationshipDataItem[];

  public onModelChange: (newValue: any) => void = () => {};
  public onModelTouched: (flag: boolean) => void = () => {};

  writeValue(value: any): void {
    this.relationshipId = value ?  value : this.relationshipId;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
      this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return c.value ? null : { invalidForm: {valid: false, message: 'Please select an option'}};
  }

  constructor(private partnershipSvc: PartnershipService) { }

  ngOnInit() {
    if (this.relationshipId) {
      this.processing = true;
      this.subscription = this.partnershipSvc.findById(this.relationshipId)
      .subscribe((partnerRelationship: PartnerRelationship[]) => {
          this.relationshipDataItem = [];
          this.relationshipDataItem = (<any>partnerRelationship).data[0].MasterDataKeys;
          this.onModelChange(this.relationshipDataItemSelected);
          this.processing = false;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.relationshipId && changes.relationshipId.currentValue) {
      if (this.relationshipId) {
        this.processing = true;
        this.subscription = this.partnershipSvc.findById(this.relationshipId)
        .subscribe((partnerRelationship: PartnerRelationship[]) => {
            this.relationshipDataItem = [];
            this.relationshipDataItem = (<any>partnerRelationship).data[0].MasterDataKeys;
            this.onModelChange(this.relationshipDataItemSelected);
            this.processing = false;
        });
      }
    }
  }

  change(newValue) {
    this.onModelChange(newValue);
    this.onChange.emit(newValue);
  }

  blur() {
    this.onModelTouched(true);
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }

}
